module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "bab-content"
    }
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteBab(_vm.datalist.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.datalist.bab_name) + " \n              "), (_vm.datalist.name !== '') ? _c('span', [_vm._v(" - " + _vm._s(_vm.datalist.name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-info btn-xs",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#addBabModal"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('editBab', _vm.datalist)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v("\n                        Edit Bab\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": function($event) {
        return _vm.addContentButton(_vm.datalist.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n                        Tambah Konten\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    class: _vm.updateState === 1 ? 'btn btn-warning btn-xs' : 'btn btn-light btn-xs',
    attrs: {
      "disabled": _vm.updateState === 1 ? false : true
    },
    on: {
      "click": function($event) {
        return _vm.updateKontenOrder(_vm.datalist.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                        Update\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "drag-content"
  }, [(_vm.list.length === 0) ? _c('div', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center"
    }
  }, [_vm._v("\n                Belum Ada Konten\n              ")]) : _vm._e(), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "list-group",
    attrs: {
      "tag": "ul",
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": 'flip-list'
    }
  }, _vm._l((_vm.list), function(element) {
    return _c('li', {
      key: element.id,
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('img', {
      attrs: {
        "src": element.type.picture,
        "width": "50"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('h6', [_c('b', [_vm._v(_vm._s(element.type.type) + " - " + _vm._s(element.title))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('button', {
      staticClass: "btn btn-danger btn-xs",
      on: {
        "click": function($event) {
          return _vm.deleteContent(element.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info btn-xs",
      on: {
        "click": function($event) {
          return _vm.editContent(element)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])])])
  }), 0)], 1)], 1)]), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "ok": function($event) {
        return _vm.removeDependency()
      },
      "cancel": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Hapus Pra-Syarat")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("Apakah anda yakin akan menghapus pra-syarat "), _c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.dependencyName))]), _vm._v(" ?")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bce549a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bimbel_online/paket_mapel/Bab.vue
// module id = 1313
// module chunks = 0